<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <input type="number" :step="stepValue" value="" v-model="internalValue" :placeholder="placeholder" @keypress="restrictChars($event)"/>
                <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value','label','name','placeholder','suffix','step','required'],
        data: function () {
            return {
                internalValue: '',
                oneTime: null
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.stepValue = this.step ? this.step : 1
            this.requiredForm = this.required && this.required == 'true' ? true : false
        },
        methods: {
            restrictChars: function($event) {
                if( this.stepValue == 1 && $event.charCode == 46 ){
                    $event.preventDefault();
                }else{
                    return true;
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal;
            },
            'internalValue'(newVal, oldVal) {
                if( newVal ){
                    let diff = Math.round(newVal%this.stepValue*100)/100
                        diff = diff >= this.stepValue ? 0 : diff
                    //console.log(newVal, this.stepValue, Math.round(newVal%this.stepValue*100)/100)
                    this.internalValue = newVal - diff;

                }
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Number.vue